import { AddSvg, Body, breakpoints, colors, Icon, Margin, Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import PlusImage from '../../../../assets/icons/AddIcon.svg'

const BUTTON_SIZE = 48
const ICON_SIZE = 24

const ButtonTextContent = styled.div`
    height: 100%;
    display: flex;
    left: ${16 + ICON_SIZE}px;
    position: absolute;
    align-items: center;
    min-width: 270px;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
`

const IconWrapper = styled.img`
    position: absolute;
    left: ${Margin.Small};
`

const ButtonComponent = styled.button<{ $disabledStyle?: boolean }>`
    display: flex;
    position: relative;
    pointer-events: all;
    justify-content: center;
    align-items: center;
    width: ${BUTTON_SIZE}px;
    height: ${BUTTON_SIZE}px;
    border-radius: ${BUTTON_SIZE / 2}px;
    border: 0;
    outline: 0;
    transition: width 0.25s ease-in-out;
    background-color: ${colors.black};
    box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    &:hover {
        cursor: pointer;
        width: 270px;
        ${ButtonTextContent} {
            opacity: 1;
        }
    }
    &:hover,
    &:focus:active {
        background-color: ${colors.charcoal};
    }
    ${breakpoints.xsmall} {
        width: 230px;
        margin-left: -40px;
        ${ButtonTextContent} {
            opacity: 1;
        }
    }
    ${({ $disabledStyle }) =>
        $disabledStyle &&
        css`
            background-color: ${colors.medGrey} !important;
            cursor: not-allowed !important;
        `}
`

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    pointer-events: none;
    position: fixed;
    width: 270px;
    bottom: 20px;
    right: ${Margin.Small};
    z-index: 1;
    ${breakpoints.xsmall} {
        right: 0;
        left: 0;
        width: 100%;
        justify-content: center;
    }
`

export const ConnectAccountFAB = ({
    onClick,
    disabled,
}: {
    onClick: () => void
    disabled?: boolean
}) => {
    return (
        <ButtonWrapper>
            <ButtonComponent disabled={disabled} $disabledStyle={!!disabled} onClick={onClick}>
                <IconWrapper src={PlusImage} />
                <ButtonTextContent>
                    <Spacer width={16} />
                    <Body.SmBold size={14} color={colors.white}>
                        Add another account
                    </Body.SmBold>
                </ButtonTextContent>
            </ButtonComponent>
        </ButtonWrapper>
    )
}
